import React, { useEffect, useRef } from 'react';

const landmarks = [
  { ic:'🚂', label:'Railway Station', val:'850 metres', sub:'Ujjain Railway Station — a short walk' },
  { ic:'⛩️', label:'Mahakal Mandir & Corridor', val:'1.5 kilometres', sub:'Sacred Mahakaleshwar Jyotirlinga + Mahakal Lok' },
  { ic:'🚌', label:'Bus Stand', val:'Nearby', sub:'Ujjain Bus Stand' },
  { ic:'🏨', label:'Hotel Address', val:'Shree Maya Comfort Inn', sub:'Ujjain, Madhya Pradesh, India' },
  { ic:'📞', label:'Call Us', val:'+91 91799 54390', sub:'Available 24 hours · Walk-ins welcome' },
];

const MapSVG = () => (
  <svg viewBox="0 0 460 420" width="100%" height="100%"
    style={{ position:'absolute', inset:0, display:'block' }}>
    <rect width="460" height="420" fill="#E8D9C4"/>
    {/* Road grid */}
    <line x1="0" y1="210" x2="460" y2="210" stroke="#C5B89A" strokeWidth="18"/>
    <line x1="230" y1="0" x2="230" y2="420" stroke="#C5B89A" strokeWidth="14"/>
    <line x1="0" y1="105" x2="460" y2="105" stroke="#CFC3A8" strokeWidth="6"/>
    <line x1="0" y1="315" x2="460" y2="315" stroke="#CFC3A8" strokeWidth="6"/>
    <line x1="115" y1="0" x2="115" y2="420" stroke="#CFC3A8" strokeWidth="5"/>
    <line x1="345" y1="0" x2="345" y2="420" stroke="#CFC3A8" strokeWidth="5"/>
    {/* Road centre lines */}
    <line x1="0" y1="210" x2="460" y2="210" stroke="#D4C9B0" strokeWidth="1.5" strokeDasharray="18 10"/>
    <line x1="230" y1="0" x2="230" y2="420" stroke="#D4C9B0" strokeWidth="1.5" strokeDasharray="18 10"/>
    {/* Blocks */}
    {[
      [22,120,80,76],[22,224,80,76],[135,120,78,76],[135,224,78,76],
      [252,120,76,76],[252,224,76,76],[360,120,78,76],[360,224,78,76],
    ].map(([x,y,w,h],i) => (
      <rect key={i} x={x} y={y} width={w} height={h} rx="3" fill="#D4C9B0" opacity="0.6"/>
    ))}
    {/* Railway Station */}
    <rect x="22" y="192" width="80" height="38" rx="3" fill="#1B2F6E" opacity=".88"/>
    <text x="62" y="208" textAnchor="middle" fontSize="7.5" fill="#E8C97A"
      fontFamily="'Cinzel',serif" letterSpacing="1.5">RAILWAY</text>
    <text x="62" y="221" textAnchor="middle" fontSize="7.5" fill="#E8C97A"
      fontFamily="'Cinzel',serif" letterSpacing="1.5">STATION</text>
    {/* Mahakal Mandir */}
    <rect x="360" y="120" width="78" height="42" rx="3" fill="#7B1F1F" opacity=".85"/>
    <text x="399" y="136" textAnchor="middle" fontSize="7" fill="#E8C97A"
      fontFamily="'Cinzel',serif" letterSpacing="1">MAHAKAL</text>
    <text x="399" y="148" textAnchor="middle" fontSize="7" fill="#E8C97A"
      fontFamily="'Cinzel',serif" letterSpacing="1">MANDIR</text>
    <text x="399" y="158" textAnchor="middle" fontSize="6.5" fill="rgba(232,200,122,.55)"
      fontFamily="'Jost',sans-serif">1.5 KM</text>
    {/* Mahakal Corridor */}
    <rect x="360" y="224" width="78" height="42" rx="3" fill="#8B4010" opacity=".85"/>
    <text x="399" y="241" textAnchor="middle" fontSize="7" fill="#E8C97A"
      fontFamily="'Cinzel',serif" letterSpacing="1">MAHAKAL</text>
    <text x="399" y="253" textAnchor="middle" fontSize="7" fill="#E8C97A"
      fontFamily="'Cinzel',serif" letterSpacing="1">CORRIDOR</text>
    <text x="399" y="262" textAnchor="middle" fontSize="6.5" fill="rgba(232,200,122,.55)"
      fontFamily="'Jost',sans-serif">1.5 KM</text>
    {/* Bus Stand */}
    <rect x="135" y="330" width="78" height="32" rx="3" fill="#1B2F6E" opacity=".65"/>
    <text x="174" y="348" textAnchor="middle" fontSize="7" fill="#E8C97A"
      fontFamily="'Jost',sans-serif" letterSpacing="2">BUS STAND</text>
    {/* Dashed distance lines */}
    <line x1="212" y1="206" x2="102" y2="206" stroke="#C9A84C" strokeWidth="1"
      strokeDasharray="5 4" opacity=".7"/>
    <line x1="248" y1="198" x2="360" y2="150" stroke="#C9A84C" strokeWidth="1"
      strokeDasharray="5 4" opacity=".7"/>
    <line x1="248" y1="222" x2="360" y2="242" stroke="#C9A84C" strokeWidth="1"
      strokeDasharray="5 4" opacity=".7"/>
    <line x1="230" y1="224" x2="186" y2="330" stroke="#C9A84C" strokeWidth="1"
      strokeDasharray="5 4" opacity=".5"/>
    {/* Distance labels */}
    <rect x="130" y="199" width="62" height="15" rx="2" fill="rgba(15,29,72,.75)"/>
    <text x="161" y="210" textAnchor="middle" fontSize="7" fill="#E8C97A"
      fontFamily="'Jost',sans-serif" letterSpacing="1">850 MTR</text>
    <rect x="280" y="165" width="56" height="14" rx="2" fill="rgba(15,29,72,.75)"/>
    <text x="308" y="175" textAnchor="middle" fontSize="7" fill="#E8C97A"
      fontFamily="'Jost',sans-serif" letterSpacing="1">1.5 KM</text>
    {/* Hotel pin — pulsing rings */}
    <circle cx="230" cy="210" r="26" fill="rgba(201,168,76,0.12)"/>
    <circle cx="230" cy="210" r="18" fill="rgba(201,168,76,0.22)"/>
    <circle cx="230" cy="210" r="11" fill="#C9A84C"/>
    <circle cx="230" cy="210" r="4.5" fill="white"/>
    {/* Hotel label */}
    <rect x="158" y="236" width="146" height="20" rx="3" fill="rgba(27,47,110,0.9)"/>
    <text x="231" y="249" textAnchor="middle" fontSize="8.5" fill="#E8C97A"
      fontFamily="'Cinzel',serif" letterSpacing="2" fontWeight="600">SHREE MAYA INN</text>
  </svg>
);

export default function Location() {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;
    ref.current.style.opacity = '0';
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        e.target.style.transition = 'opacity .9s ease';
        e.target.style.opacity = '1';
      }
    }, { threshold: 0.08 });
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <>
      <style>{`
        .loc-item { display:flex; align-items:flex-start; gap:1.2rem;
          padding:1.2rem 0; border-bottom:1px solid rgba(242,232,217,0.1); }
        .loc-item:last-child { border-bottom:none; }
        @media(max-width:860px){
          .loc-grid { grid-template-columns:1fr !important; }
          .loc-map { min-height:280px !important; }
        }
      `}</style>

      <section id="location" style={{ padding:'7rem 3rem', background:'#F2E8D9' }}>
        <div style={{ maxWidth:'1100px', margin:'0 auto' }}>
          <div style={{ textAlign:'center', marginBottom:'3rem' }}>
            <div style={{ display:'flex', alignItems:'center', gap:'.8rem', justifyContent:'center', marginBottom:'1rem' }}>
              <div style={{ width:'32px', height:'1px', background:'#C9A84C' }}/>
              <div style={{ width:'5px', height:'5px', background:'#C9A84C', transform:'rotate(45deg)' }}/>
              <div style={{ width:'32px', height:'1px', background:'#C9A84C' }}/>
            </div>
            <p style={{ fontFamily:"'Jost',sans-serif", fontSize:'.58rem', letterSpacing:'5px',
              textTransform:'uppercase', color:'#1B2F6E', marginBottom:'.7rem', fontWeight:400 }}>
              Find Us
            </p>
            <h2 style={{ fontFamily:"'Cinzel',serif", fontSize:'clamp(1.9rem,4vw,2.9rem)',
              fontWeight:500, color:'#1B2F6E', marginBottom:'.2rem' }}>
              Ideally Located
            </h2>
            <h3 style={{ fontFamily:"'Cormorant',serif", fontSize:'clamp(1.2rem,2.5vw,1.8rem)',
              fontStyle:'italic', fontWeight:400, color:'#C9A84C' }}>
              Gateway to Mahakal &amp; beyond
            </h3>
          </div>

          <div ref={ref} className="loc-grid" style={{
            display:'grid', gridTemplateColumns:'1fr 1.05fr',
            border:'1px solid rgba(201,168,76,0.25)', overflow:'hidden',
          }}>
            {/* Map */}
            <div className="loc-map" style={{ position:'relative', minHeight:'440px', background:'#E8D9C4' }}>
              <MapSVG/>
            </div>

            {/* Info */}
            <div style={{ background:'#1B2F6E', padding:'2.8rem 2.5rem' }}>
              <p style={{ fontFamily:"'Cinzel',serif", fontSize:'.8rem', letterSpacing:'3px',
                color:'#C9A84C', marginBottom:'1.5rem', fontWeight:500 }}>
                DISTANCES FROM HOTEL
              </p>
              {landmarks.map((l) => (
                <div key={l.label} className="loc-item">
                  <div style={{ fontSize:'1.1rem', flexShrink:0, marginTop:'2px' }}>{l.ic}</div>
                  <div>
                    <div style={{ fontFamily:"'Jost',sans-serif", fontSize:'.55rem',
                      letterSpacing:'3px', textTransform:'uppercase',
                      color:'rgba(201,168,76,0.75)', marginBottom:'.25rem' }}>
                      {l.label}
                    </div>
                    <div style={{ fontFamily:"'Cinzel',serif", fontSize:'1rem',
                      color:'#F2E8D9', lineHeight:1.3 }}>{l.val}</div>
                    <div style={{ fontFamily:"'EB Garamond',serif", fontStyle:'italic',
                      fontSize:'.88rem', color:'rgba(242,232,217,0.42)', marginTop:'2px' }}>
                      {l.sub}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
